import { cva } from 'class-variance-authority'

export const iconTextStyles = cva('inline-flex items-center gap-2', {
  variants: {
    size: {
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-base',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
})
